import { CSSProperties } from 'react';
import {
  DateTimePicker as MUIDateTimePicker,
  DateTimePickerProps as MUIDateTimePickerProps,
} from '@mui/x-date-pickers/DateTimePicker';
import { PickersActionBarAction } from '@mui/x-date-pickers/PickersActionBar';

import colors from '@atom/styles/colors';

import PickerTextField from './PickerTextField';

const styles = {
  pickerIcon: {
    color: colors.neutral.gray,
  },
};

type CustomProps = {
  // Hides the clear button in the date time picker menu
  hideClear?: boolean;
};

type AtomMUIProps = {
  value: Date;
  onChange: (date: Date) => void;
  onClick?: () => void;
  style?: CSSProperties;
  disabled?: boolean;
  label?: string;
  error?: boolean;
  helperText?: string;
  InputProps?: any;
  InputLabelProps?: any;
  shouldDisableDate?: (date: Date) => boolean;
};

export type DateTimePickerPropsNew = CustomProps & AtomMUIProps;

export const DateTimePicker = (props: DateTimePickerPropsNew) => {
  const {
    error,
    helperText,
    InputProps,
    InputLabelProps,
    style,
    onClick,
    hideClear,
    ...data
  } = props;
  const MUIProps: MUIDateTimePickerProps = data;

  const actions: PickersActionBarAction[] = hideClear
    ? ['accept', 'cancel']
    : ['accept', 'cancel', 'clear'];

  return (
    <div style={{ width: '100%', ...style }}>
      <MUIDateTimePicker
        {...MUIProps}
        fullWidth
        slots={{ textField: PickerTextField }}
        slotProps={{
          actionBar: {
            actions,
          },
          textField: {
            fullWidth: true,
            error,
            helperText,
            InputProps,
            InputLabelProps,
            onClick,
          },
          openPickerIcon: {
            style: styles.pickerIcon,
          },
        }}
      />
    </div>
  );
};
